import {useQuery, UseQueryResult} from "react-query";
import {getNumberModule} from "./moduleFxNumber.services";


export const useGetNumberModule = (id:number):UseQueryResult<ModuleFxNumber, Error>=>{
    return useQuery<ModuleFxNumber, Error>(["modulefx", id], ()=>getNumberModule(id), {
        enabled:id!==0
    })
}